"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.6965559,6.27668537 L21.8268863,15.0324157 C22.0577046,15.253764 22.0577046,15.6126405 21.8268863,15.8339888 C21.7160434,15.940284 21.5657082,16 21.4089527,16 L2.5910473,16 C2.26462089,16 2,15.746236 2,15.4332022 C2,15.2828781 2.06227088,15.1387109 2.17311375,15.0324157 L11.3034441,6.27668537 C11.6881413,5.90777154 12.3118587,5.90777154 12.6965559,6.27668537 Z"
  });
}.bind(void 0));

exports.default = _default;